import { createAction } from '@reduxjs/toolkit';
import type { IHistoryPush } from 'reactApp/modules/router/router.types';

export const changeSearchHistory = createAction<IHistoryPush>('search/changeHistory');
